export default "images/node-js-logo.png";